import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nomination-approval-form',
  templateUrl: './nomination-approval-form.component.html',
  styleUrls: ['./nomination-approval-form.component.css']
})
export class NominationApprovalFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Nomination/nomination-approval/nomination-approval-form/nomination-approval-form.component.ts